// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".uk-container[data-v-4b98c0c7]{padding-top:30px;padding-bottom:30px}\n", ""]);
// Exports
module.exports = exports;
